import { createFileRoute } from '@tanstack/react-router'
import { ProfileSettingsPage } from '../components/auth-pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fr/parametres/profil')({
  head: () => noIndexRouteHead('settingsProfile', 'fr'),
  component: ProfileSettingsPage,
})
